import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { ReferralTemplateModal } from "@features/Referral/components/ReferralTemplateModal/ReferralTemplateModal";
import { Button } from "@components/Button/Button";
import { ReceiptIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { useModalStore, type IUseModalProps } from "@store/modal/modal";
import { useAcceptReferralRulesMutation } from "@services/referrals/mutations";
import { sanitizeHtml } from "@utils/html";

export const ReferralRulesModal: React.FC<IUseModalProps> = (props) => {
  const { t } = useTranslation();
  const { create } = useModalStore();
  const modal = useModal(props);
  const { mutateAsync: accept, isPending } = useAcceptReferralRulesMutation();

  const openTemplateModal = () => {
    create((modalProps) => <ReferralTemplateModal {...modalProps} />);
  };

  const acceptRules = () => {
    accept()
      .then(() => {
        modal.close();
        openTemplateModal();
      })
      .catch(() => {
        toast.error(t("referral.rulesModal.toast.error"));
      });
  };

  return (
    <Modal
      modal={modal}
      badgeProps={{ icon: ReceiptIcon }}
      actionButtons={
        <React.Fragment>
          <Button variant="secondary" onClick={modal.close} className="w-full">
            {t("referral.rulesModal.buttons.cancel")}
          </Button>
          <Button
            onClick={acceptRules}
            className="w-full"
            isLoading={isPending}
          >
            {t("referral.rulesModal.buttons.submit")}
          </Button>
        </React.Fragment>
      }
      title={t("referral.rulesModal.title")}
    >
      <div
        className="h-80 w-full overflow-auto"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(t("referral.rulesModal.rules")),
        }}
      />
    </Modal>
  );
};
